import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPageEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPageEmpty"><Path d="M4.5 2.5H19.5V21.5H4.5V2.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconPageEmpty;
